import {SearchQueryParams} from '../search_api/search_constants';
import {QueryItemBuilder} from './builders/query_item_builder';

export interface ApplicationRequestConfig {
  application: string;
  source: string;
  version: string;
  uid: string;
  authorization: string;
}

export class ApplicationRequestConfigQueryBuilder {
  static buildQueryString(applicationRequestConfig: ApplicationRequestConfig): string {
    return QueryItemBuilder.valueProp(applicationRequestConfig.application, SearchQueryParams.APPLICATION_SEARCH)
      + QueryItemBuilder.valueProp(applicationRequestConfig.source, SearchQueryParams.RECORD_SOURCE);
  }
}
